export class AdmissionProcedure {
    public idAdmissionProcedure: number;
    public idAdmissionGuide: number;
    public datetimeInclusion: Date;
    public idTerminology: number;
    public procedureCodeItem: string;
    public procedureDescription: string;
    public procedureCount: number;
    public procedureCountAuthorized: number;
}